import { Controller } from "@hotwired/stimulus"

/**
 * Color Picker Controller
 *
 * Syncs a color input (picker) with a text input for hex values.
 * Allows users to either pick a color visually or type a hex code.
 */
export default class extends Controller {
  static targets = ["picker", "text"]

  /**
   * Sync color picker value to text input
   */
  syncToText() {
    if (this.hasTextTarget && this.hasPickerTarget) {
      this.textTarget.value = this.pickerTarget.value
      // Fire a bubbling input event on the NAMED text field so listeners that
      // key off form fields (e.g. live-preview controllers filtering on
      // [name]) react to swatch picks too — the swatch itself has no name.
      this.textTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  /**
   * Sync text input value to color picker (if valid hex)
   */
  syncToPicker() {
    if (this.hasTextTarget && this.hasPickerTarget) {
      const value = this.textTarget.value.trim()
      // Only sync if it's a valid 6-digit hex color
      if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
        this.pickerTarget.value = value
      }
    }
  }
}
